import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import LogoutIcon from '@mui/icons-material/Logout';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { authApi } from '@/features/auth/api/auth.api';
import { BrandLogo } from '@/shared/components/BrandLogo';

/**
 * Chrome for the authenticated guide-lifecycle screens (application status and
 * profile setup). Deliberately minimal — an applicant has no guide dashboard
 * yet. They are still a traveler, though, so there is a way back to the
 * traveler app; without it, signing out is the only exit.
 */
export function GuideLifecycleLayout() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      await authApi.logout();
    } finally {
      logout();
      navigate('/', { replace: true });
    }
  };

  return (
    <Box
      sx={{
        height: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        bgcolor: 'background.default',
      }}
    >
      <AppBar
        position="static"
        elevation={0}
        sx={{
          flexShrink: 0,
          bgcolor: 'background.paper',
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Toolbar
          sx={{
            justifyContent: 'space-between',
            minHeight: { xs: 64, md: 72 },
            height: { xs: 64, md: 72 },
            px: { xs: 2, sm: 3 },
          }}
        >
          <BrandLogo
            size="xl"
            surface="light"
            responsiveHeight={{ xs: 44, sm: 50, md: 56 }}
          />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Button
              size="small"
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate('/')}
              sx={{ color: 'text.secondary' }}
            >
              Back to Trplin
            </Button>
            <Button
              size="small"
              startIcon={<LogoutIcon />}
              onClick={() => void handleLogout()}
              sx={{ color: 'text.secondary' }}
            >
              Sign Out
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      <Box
        component="main"
        sx={{
          position: 'relative',
          flex: 1,
          minHeight: 0,
          overflow: 'auto',
          bgcolor: 'background.default',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
